import {Component, OnDestroy} from '@angular/core';
import {AuthService} from '../../../services/auth/auth.service';
import {TranslateService} from '@ngx-translate/core';
import {RouteService} from '../../../services/route/route.service';
import {SnackService} from '../../../services/snack/snack.service';
import {ViewService} from '../../../services/view/view.service';
import {ValidationService} from '../../../services/validation/validation.service';
import {UtilService} from '../../../services/util/util.service';
import {finalize} from "rxjs/operators";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./../login.component.scss']
})
export class ChangePasswordComponent implements OnDestroy {
  public username: string;
  public oldPassword: string;
  public newPassword: string;
  public newPasswordRepeat: string;
  public isLoading = false;
  private _subscriptions: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private routeService: RouteService,
    private translateService: TranslateService,
    private snackService: SnackService,
    public viewService: ViewService,
    public utilService: UtilService) {}

  ngOnDestroy(): void {
    this._subscriptions.forEach(value =>  value.unsubscribe() );
  }

  get passwordsMatch(): boolean {
    return this.newPassword === this.newPasswordRepeat;
  }

  get validPassword(): boolean {
    return ValidationService.validatePassword(this.newPassword);
  }

  get checkPassword(): boolean {
    return this.validPassword && this.passwordsMatch;
  }

  public submit(): void {
    this.isLoading = true;
    const sub = this.authService.updateUser(this.oldPassword, this.newPassword).pipe(
      finalize(() => {
        this.goBack();
        this.isLoading = false;
      }
    )).subscribe(() => this.snackService.showSuccess(this.translateService.instant('general.api_change_password_succeed')));
    this._subscriptions.push(sub);
  }

  goBack(): void {
    this.routeService.back();
  }
}
